'use client';

import * as React from 'react';
import Box from '@mui/material/Box';

// const icons: Record<string, string> = {
//   jpeg: '/assets/icon-jpg.svg',
//   jpg: '/assets/icon-jpg.svg',
//   mp4: '/assets/icon-mp4.svg',
//   pdf: '/assets/icon-pdf.svg',
//   png: '/assets/icon-png.svg',
//   svg: '/assets/icon-svg.svg',
// };

export interface FileIconProps {
  path: string;
  extension?: string;
}

export function FileIcon({ path }: FileIconProps): React.JSX.Element {
  // let icon: string;
  const [preview, setPreview] = React.useState<string | undefined>(undefined);

  // if (!extension) {
  //   icon = '/assets/icon-other.svg';
  // }
  // else {
  //   icon = icons[extension] ?? '/assets/icon-other.svg';
  // }

  return (
    <Box
      sx={{
        alignItems: 'center',
        display: 'inline-flex',
        flex: '0 0 auto',
        justifyContent: 'center',
        width: 1,
        height: '60px',
      }}
    >
      <Box
        alt="File"
        component="img"
        src={
          preview === ''
            ? '/assets/not-found.svg'
            : preview && preview !== ''
              ? preview
              : `${process.env.NEXT_PUBLIC_CMS_V2_IMAGES_URL}${path}`
        }
        sx={{ height: '100%', width: 'auto', objectFit: 'contain' }}
        onError={() => {
          setPreview('');
        }}
      />
    </Box>
  );
}
